module.exports = __webpack_public_path__ + "static/media/mulher-startup.6073f3f8.png";